'use strict'

import PhotoSwipeLightbox from '../libs/photoswipe/dist/photoswipe-lightbox.esm.min.js';

const Selectors = {
    base: '.js-pdsLightbox',
    item: '.js-pdsLightbox__item',
    productTitle: '.product-detail__title'
};

const Attributes = {
    pdsLightboxTitle: 'data-pdsLightbox-title'
}

const pdsLightboxArrowString = `<svg width="800.17" height="800" viewBox="0 0 800.17 800" aria-hidden="true" class="pswp__icn">
    <path d="M790.56,376.28l-211.59-211.59c-4.92-4.92-11.61-7.69-18.57-7.69h-78.9c-8.78,0-13.17,10.61-6.97,16.82l160.07,160.08s7.89,7.22,15.04,12.36c2.89,2.08,8.28,5.38,13.68,8.59H9.63c-.32,0-1.38,0-1.68,0-3.94,0-7.14,3.2-7.14,7.14v75.35c0,3.94,2.91,6.73,6.85,6.73,.6,0,1.43,.21,1.99,.07H663.32c-5.4,3.21-10.79,6.52-13.68,8.59-7.15,5.14-15.04,12.36-15.04,12.36l-160.07,160.08c-6.2,6.21-1.81,16.82,6.97,16.82h78.9c6.97,0,13.65-2.77,18.57-7.69l211.59-211.59c12.82-12.82,12.82-33.61,0-46.44"/>
</svg>`

const pdsLightboxZoomString = `<svg width="800.17" height="800" viewBox="0 0 800.17 800" aria-hidden="true" class="pswp__icn pswp__icn--zoom-in">
    <path d="M675.31,436.45c0,3.8-2.28,6.48-5.36,6.48-.47,0-1.12,.2-1.56,.06-.56,0-9.72,0-25.21,0v.05h-200.14v225.36c0,.25,0,1.08,0,1.31,0,3.08-3.08,5.59-6.88,5.59h-72.61c-3.8,0-6.48-2.28-6.48-5.37,0-.47-.2-1.11-.07-1.56v-25.21h-.05v-200.13H131.59c-.25,0-1.08,0-1.31,0-3.09,0-5.59-3.08-5.59-6.88v-72.62c0-3.8,2.28-6.48,5.36-6.48,.47,0,1.12-.2,1.56-.06h25.22v-.05h200.13V131.59c0-.25,0-1.09,0-1.31,0-3.09,3.08-5.59,6.88-5.59h72.61c3.8,0,6.48,2.27,6.48,5.36,0,.47,.2,1.12,.07,1.56v25.21h.05v200.14h225.36c.25,0,1.08,0,1.31,0,3.09,0,5.59,3.07,5.59,6.88v72.61Zm-63.37-375.63C424.62-56.22,177.88,.75,60.82,188.07-56.22,375.38,.74,622.12,188.06,739.18c187.32,117.05,434.06,60.08,551.11-127.24,117.05-187.32,60.08-434.06-127.24-551.11"/>
</svg>
<svg width="800.17" height="800" viewBox="0 0 800.17 800" aria-hidden="true" class="pswp__icn pswp__icn--zoom-out">
    <path d="M675.31,436.45c0,3.8-2.28,6.48-5.36,6.48-.47,0-1.12,.2-1.56,.07-.56,0-531.16,.05-536.81,.05-.25,0-1.08,0-1.31,0-3.09,0-5.59-3.08-5.59-6.88v-72.62c0-3.8,2.28-6.48,5.36-6.48,.47,0,1.12-.2,1.56-.06,.56,0,531.16-.05,536.81-.05,.25,0,1.08,0,1.31,0,3.09,0,5.59,3.07,5.59,6.88v72.61m-63.37-375.63C424.62-56.22,177.88,.75,60.82,188.07-56.22,375.38,.74,622.12,188.06,739.17c187.32,117.05,434.06,60.09,551.11-127.23,117.05-187.32,60.08-434.06-127.24-551.11"/>
</svg>`

const pdsLightboxCloseString = `<svg width="800.17" height="800" viewBox="0 0 800.17 800" aria-hidden="true" class="pswp__icn pswp__icn--close">
    <path d="M675.31,436.45c0,3.8-2.28,6.48-5.36,6.48-.47,0-1.12,.2-1.56,.06-.56,0-9.72,0-25.21,0v.05h-200.14v225.36c0,.25,0,1.08,0,1.31,0,3.08-3.08,5.59-6.88,5.59h-72.61c-3.8,0-6.48-2.28-6.48-5.37,0-.47-.2-1.11-.07-1.56v-25.21h-.05v-200.13H131.59c-.25,0-1.08,0-1.31,0-3.09,0-5.59-3.08-5.59-6.88v-72.62c0-3.8,2.28-6.48,5.36-6.48,.47,0,1.12-.2,1.56-.06h25.22v-.05h200.13V131.59c0-.25,0-1.09,0-1.31,0-3.09,3.08-5.59,6.88-5.59h72.61c3.8,0,6.48,2.27,6.48,5.36,0,.47,.2,1.12,.07,1.56v25.21h.05v200.14h225.36c.25,0,1.08,0,1.31,0,3.09,0,5.59,3.07,5.59,6.88v72.61Zm-63.37-375.63C424.62-56.22,177.88,.75,60.82,188.07-56.22,375.38,.74,622.12,188.06,739.18c187.32,117.05,434.06,60.08,551.11-127.24,117.05-187.32,60.08-434.06-127.24-551.11"/>
</svg>`

export function init() {
    const productTitleEl = document.querySelector(Selectors.productTitle);
    const lightboxProductTitle = productTitleEl ? productTitleEl.getAttribute(Attributes.pdsLightboxTitle) : false;

    const lightbox = new PhotoSwipeLightbox({
        bgOpacity: 1,
        gallery: Selectors.base,
        children: Selectors.item,
        pswpModule: () => import ('../libs/photoswipe/dist/photoswipe.esm.min.js'),
        counter: false,
        arrowPrevSVG: pdsLightboxArrowString,
        arrowNextSVG: pdsLightboxArrowString,
        closeSVG: pdsLightboxCloseString,
        zoomSVG: pdsLightboxZoomString,
        paddingFn: (viewportSize, itemData, index) => {
            return {
                top: viewportSize.x < 768 ? 0 : 45,
                bottom: viewportSize.x < 768 ? 0 : 45,
                right: viewportSize.x < 768 ? 30 : 5,
                left: viewportSize.x < 768 ? 30 : 5
            };
        }
    });

    if (lightboxProductTitle && lightboxProductTitle.length) {
        lightbox.on('uiRegister', function() {
            lightbox.pswp.ui.registerElement({
                name: 'product-title',
                order: 6,
                tagName: 'h6',
                className: 'font-default pswp__product-title lg-sub-html',
                appendTo: 'wrapper',
                onInit: (el, pswp) => {
                    el.innerText = lightboxProductTitle;
                }
            });
        });
    }

    lightbox.init();
}
